export const hero = {
  title: 'Cambiare è possibile, stare meglio è possibile!',
  image: 'heroMainImage',
  metadata: {
    priority: 1,
    section: 'hero'
  }
};